// @flow

import { type IncomingPayment, type IncomingPaymentStatus } from './types';

export function getStatus(incomingPayment: IncomingPayment): IncomingPaymentStatus {
  return incomingPayment['status'];
}
